import { Component } from '@angular/core';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.css'],
  imports: [ToastModule],
})
export class ToastComponent {
  life: number = 6000;
  constructor() {}
}
